var _path, _path2, _path3, _path4, _path5, _g, _g2, _path6, _path7, _g3, _g4, _g5, _path8, _path9, _path10, _path11, _rect, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgManedsbelp(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 197,
    height: 202,
    viewBox: "0 0 197 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M86.2405 87.6448C83.1326 92.5819 76.9068 97.095 71.1085 99.956C68.87 101.06 65.1657 102.715 61.4112 102.34C57.9652 101.997 55.2413 101.636 52.5504 96.497C50.6051 92.7821 50.2631 90.2955 49.7323 87.0807C49.2181 83.966 49.1288 82.2593 45.662 81.7334C41.9703 81.1733 38.7239 78.2698 37.9414 75.0311C37.1946 71.9411 48.2923 75.9021 52.9644 75.5697C57.6371 75.237 57.3001 77.8399 58.0325 82.7866C58.3515 84.9398 59.1344 86.4229 62.1563 87.2033C65.1782 87.9837 66.6603 86.1109 69.5786 84.4731C72.497 82.8352 87.9724 84.8936 86.2405 87.6448Z",
    fill: "#FFE1D1",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M86.2498 87.6407C83.1419 92.5778 76.9034 97.091 71.1057 99.9516C71.0366 99.9855 70.9141 100.024 70.8426 100.059C69.9526 98.7867 69.1093 97.5045 68.3444 96.1315C67.1596 94.0049 66.0745 90.539 65.5221 86.8701C66.7662 86.31 67.9658 85.3859 69.5858 84.4763C73.1963 82.4492 77.8897 80.2766 80.2149 79.7792C88.6216 77.9808 87.6065 85.4856 86.2498 87.6407Z",
    fill: "#B8FFEE",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M174.109 86.1461C179.708 87.7847 185.756 92.5506 190.094 97.3445C190.145 97.4017 190.216 97.5089 190.269 97.5681C189.289 98.7723 188.286 99.9342 187.174 101.046C185.454 102.767 182.417 104.759 179.039 106.294C178.16 105.25 176.943 104.349 175.625 103.04C173.251 100.681 170.989 85.2328 174.109 86.1461Z",
    fill: "#B8FFEE",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M100.622 150.386C100.622 150.386 98.4595 180.03 97.3456 186.991C96.2318 193.952 81.8234 191.852 79.6232 195.554C77.423 199.257 79.9576 200.001 79.9576 200.001L108.318 199.849C108.318 199.849 114.23 200.526 115.2 198.613C117.936 193.215 125.663 150.534 125.663 150.534L100.622 150.386Z",
    fill: "#FFE1D1",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M100.619 150.389C100.619 150.389 99.3162 168.067 98.2104 179.311H120.018C122.853 165.791 125.665 150.533 125.665 150.533L100.619 150.389Z",
    fill: "#B8FFEE",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M108.321 150.508C107.161 152.827 107.921 155.42 107.309 157.869C106.486 161.162 106.573 166.291 106.573 169.738C106.573 171.929 106.085 174.264 105.561 176.363C105.395 177.027 105.327 177.714 105.192 178.387C105.165 178.522 105.101 179.468 105.101 179.03",
    fill: "#B8FFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108.321 150.508C107.161 152.827 107.921 155.42 107.309 157.869C106.486 161.162 106.573 166.291 106.573 169.738C106.573 171.929 106.085 174.264 105.561 176.363C105.395 177.027 105.327 177.714 105.192 178.387C105.165 178.522 105.101 179.468 105.101 179.03",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M117.21 150.579C117.126 150.547 116.922 150.781 116.864 150.879C116.469 151.54 116.159 154.603 115.995 155.535C115.593 157.828 115.551 160.344 115.463 162.684C115.347 165.819 114.625 169.016 114.189 172.098C113.959 173.728 113.799 175.42 113.348 177.015C113.215 177.484 112.865 179.603 112.801 178.997",
    fill: "#B8FFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.21 150.579C117.126 150.547 116.922 150.781 116.864 150.879C116.469 151.54 116.159 154.603 115.995 155.535C115.593 157.828 115.551 160.344 115.463 162.684C115.347 165.819 114.625 169.016 114.189 172.098C113.959 173.728 113.799 175.42 113.348 177.015C113.215 177.484 112.865 179.603 112.801 178.997",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M155.653 150.386C155.653 150.386 157.815 180.03 158.929 186.991C160.043 193.952 174.452 191.852 176.652 195.554C178.852 199.257 176.318 200.001 176.318 200.001L147.956 199.849C147.956 199.849 142.046 200.526 141.076 198.613C138.339 193.215 130.612 150.534 130.612 150.534L155.653 150.386Z",
    fill: "#FFE1D1",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M155.656 150.389C155.656 150.389 156.959 168.067 158.065 179.311H136.257C133.423 165.791 130.61 150.533 130.61 150.533L155.656 150.389Z",
    fill: "#B8FFEE",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M147.956 150.508C149.115 152.827 148.355 155.42 148.968 157.869C149.791 161.162 149.704 166.291 149.704 169.738C149.704 171.929 150.191 174.264 150.716 176.363C150.882 177.027 150.95 177.714 151.084 178.387C151.111 178.522 151.176 179.468 151.176 179.03",
    fill: "#B8FFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.956 150.508C149.115 152.827 148.355 155.42 148.968 157.869C149.791 161.162 149.704 166.291 149.704 169.738C149.704 171.929 150.191 174.264 150.716 176.363C150.882 177.027 150.95 177.714 151.084 178.387C151.111 178.522 151.176 179.468 151.176 179.03",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M139.065 150.579C139.149 150.547 139.352 150.781 139.411 150.879C139.806 151.54 140.116 154.603 140.279 155.535C140.682 157.828 140.724 160.344 140.811 162.684C140.928 165.819 141.65 169.016 142.085 172.098C142.316 173.728 142.475 175.42 142.927 177.015C143.059 177.484 143.409 179.603 143.473 178.997",
    fill: "#B8FFEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.065 150.579C139.149 150.547 139.352 150.781 139.411 150.879C139.806 151.54 140.116 154.603 140.279 155.535C140.682 157.828 140.724 160.344 140.811 162.684C140.928 165.819 141.65 169.016 142.085 172.098C142.316 173.728 142.475 175.42 142.927 177.015C143.059 177.484 143.409 179.603 143.473 178.997",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.983635
  }, /*#__PURE__*/React.createElement("path", {
    d: "M84.0424 35.4473H170.637C172.892 35.4473 174.721 37.2758 174.721 39.5311V148.722C174.721 150.977 172.892 152.806 170.637 152.806H84.0424C81.787 152.806 79.9585 150.977 79.9585 148.722V39.5311C79.9585 37.2758 81.787 35.4473 84.0424 35.4473Z",
    fill: "#2D0067",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.3237 46.4324H161.01C162.137 46.4324 163.051 47.3461 163.051 48.4743V67.9747C163.051 69.1024 162.137 70.0167 161.01 70.0167H93.3237C92.196 70.0167 91.2817 69.1024 91.2817 67.9747V48.4743C91.2817 47.3461 92.196 46.4324 93.3237 46.4324Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2802 78.5901H102.511C103.638 78.5901 104.553 79.5039 104.553 80.632V89.8651C104.553 90.9928 103.638 91.907 102.511 91.907H93.2802C92.1526 91.907 91.2383 90.9928 91.2383 89.8651V80.632C91.2383 79.5039 92.1526 78.5901 93.2802 78.5901Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.779 78.5901H122.01C123.137 78.5901 124.052 79.5039 124.052 80.632V89.8651C124.052 90.9928 123.137 91.907 122.01 91.907H112.779C111.652 91.907 110.737 90.9928 110.737 89.8651V80.632C110.737 79.5039 111.652 78.5901 112.779 78.5901Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28 78.5901H141.51C142.638 78.5901 143.552 79.5039 143.552 80.632V89.8651C143.552 90.9928 142.638 91.907 141.51 91.907H132.28C131.152 91.907 130.238 90.9928 130.238 89.8651V80.632C130.238 79.5039 131.152 78.5901 132.28 78.5901Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.781 78.5901H161.011C162.139 78.5901 163.053 79.5039 163.053 80.632V89.8651C163.053 90.9928 162.139 91.907 161.011 91.907H151.781C150.653 91.907 149.739 90.9928 149.739 89.8651V80.632C149.739 79.5039 150.653 78.5901 151.781 78.5901Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2802 96.5796H102.511C103.638 96.5796 104.553 97.4934 104.553 98.6215V107.855C104.553 108.982 103.638 109.897 102.511 109.897H93.2802C92.1526 109.897 91.2383 108.982 91.2383 107.855V98.6215C91.2383 97.4934 92.1526 96.5796 93.2802 96.5796Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.779 96.5796H122.01C123.137 96.5796 124.052 97.4934 124.052 98.6215V107.855C124.052 108.982 123.137 109.897 122.01 109.897H112.779C111.652 109.897 110.737 108.982 110.737 107.855V98.6215C110.737 97.4934 111.652 96.5796 112.779 96.5796Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28 96.5796H141.51C142.638 96.5796 143.552 97.4934 143.552 98.6215V107.855C143.552 108.982 142.638 109.897 141.51 109.897H132.28C131.152 109.897 130.238 108.982 130.238 107.855V98.6215C130.238 97.4934 131.152 96.5796 132.28 96.5796Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.781 96.5796H161.011C162.139 96.5796 163.053 97.4934 163.053 98.6215V107.855C163.053 108.982 162.139 109.897 161.011 109.897H151.781C150.653 109.897 149.739 108.982 149.739 107.855V98.6215C149.739 97.4934 150.653 96.5796 151.781 96.5796Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2802 114.57H102.511C103.638 114.57 104.553 115.484 104.553 116.612V125.845C104.553 126.973 103.638 127.887 102.511 127.887H93.2802C92.1526 127.887 91.2383 126.973 91.2383 125.845V116.612C91.2383 115.484 92.1526 114.57 93.2802 114.57Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.455 114.57H122.686C123.814 114.57 124.727 115.484 124.727 116.612V125.845C124.727 126.973 123.814 127.887 122.686 127.887H113.455C112.327 127.887 111.413 126.973 111.413 125.845V116.612C111.413 115.484 112.327 114.57 113.455 114.57Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28 114.57H141.51C142.638 114.57 143.552 115.484 143.552 116.612V125.845C143.552 126.973 142.638 127.887 141.51 127.887H132.28C131.152 127.887 130.238 126.973 130.238 125.845V116.612C130.238 115.484 131.152 114.57 132.28 114.57Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M93.2802 132.559H102.511C103.638 132.559 104.553 133.474 104.553 134.601V143.835C104.553 144.963 103.638 145.877 102.511 145.877H93.2802C92.1526 145.877 91.2383 144.963 91.2383 143.835V134.601C91.2383 133.474 92.1526 132.559 93.2802 132.559Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.779 132.559H122.01C123.137 132.559 124.052 133.474 124.052 134.601V143.835C124.052 144.963 123.137 145.877 122.01 145.877H112.779C111.652 145.877 110.737 144.963 110.737 143.835V134.601C110.737 133.474 111.652 132.559 112.779 132.559Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.28 132.559H141.51C142.638 132.559 143.552 133.474 143.552 134.601V143.835C143.552 144.963 142.638 145.877 141.51 145.877H132.28C131.152 145.877 130.238 144.963 130.238 143.835V134.601C130.238 133.474 131.152 132.559 132.28 132.559Z",
    fill: "#E3E4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.78 114.57H161.011C162.138 114.57 163.053 115.534 163.053 116.724V143.723C163.053 144.913 162.138 145.877 161.011 145.877H151.78C150.653 145.877 149.738 144.913 149.738 143.723V116.724C149.738 115.534 150.653 114.57 151.78 114.57Z",
    fill: "#E3E4FF"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M190.272 97.5676C189.291 98.7719 188.289 99.9337 187.177 101.045C185.456 102.766 182.419 104.758 179.041 106.293C179.745 107.129 180.252 108.048 180.286 109.436C180.362 112.556 177.523 114.443 174.719 115.166C170.937 116.141 165.201 115.859 161.472 117.481C157.195 119.341 159 122.506 163.051 124.536C166.467 126.249 171.163 127.106 174.719 126.567C177.915 126.082 182.529 124.554 186.289 122.212C190.096 119.841 192.548 117.334 193.482 115.736C195.435 112.396 195.654 109.431 195.042 106.022C194.395 102.423 191.948 99.436 190.272 97.5676Z",
    fill: "#FFE1D1",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M102.194 14.7788L115.268 26.6652",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M128.327 26.6656V7.40967",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.983635,
    d: "M141.769 26.6652L148.129 20.5237L154.078 14.7788",
    stroke: "#2D0067",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15.2705,
    y: 1.19866,
    width: 47.0515,
    height: 59.8718,
    rx: 3,
    transform: "rotate(12.9493 15.2705 1.19866)",
    fill: "#F8F2FF",
    stroke: "#2D0067",
    strokeWidth: 2
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3164 15.4703L18.3618 10.6521L17.7419 13.3481L38.6965 18.1663L39.3164 15.4703Z",
    fill: "#2D0067"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3496 22.6131L16.9043 16.9922L16.2844 19.6882L40.7297 25.3091L41.3496 22.6131Z",
    fill: "#2D0067"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M30.344 34.6024L13.7334 30.783L13.1135 33.479L29.7241 37.2984L30.344 34.6024Z",
    fill: "#2D0067"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7997 42.3989L12.3545 36.7781L11.7346 39.4741L36.1798 45.0949L36.7997 42.3989Z",
    fill: "#2D0067"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7514 55.6599L9.30615 50.0391L8.68624 52.7351L33.1315 58.3559L33.7514 55.6599Z",
    fill: "#2D0067"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M36.271 28.7125L15.3164 23.8943L14.6965 26.5903L35.6511 31.4085L36.271 28.7125Z",
    fill: "#2D0067"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0504 18.814L49.3369 17.7302L48.717 20.4262L53.4305 21.51L54.0504 18.814Z",
    fill: "#2D0067"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M52.5284 25.4344L47.8149 24.3506L47.195 27.0466L51.9085 28.1304L52.5284 25.4344Z",
    fill: "#2D0067"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.005 32.0562L46.2915 30.9724L45.6716 33.6684L50.3851 34.7522L51.005 32.0562Z",
    fill: "#2D0067"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M49.4801 38.6951L44.7666 37.6113L44.1467 40.3073L48.8602 41.3911L49.4801 38.6951Z",
    fill: "#2D0067"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9581 45.3138L43.2446 44.23L42.6247 46.926L47.3382 48.0098L47.9581 45.3138Z",
    fill: "#2D0067"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9078 58.5762L40.1943 57.4924L39.5744 60.1884L44.2879 61.2722L44.9078 58.5762Z",
    fill: "#2D0067"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M67.5256 43.7125C67.5256 46.2732 65.4497 48.3491 62.889 48.3491C60.3283 48.3491 58.2524 46.2732 58.2524 43.7125C58.2524 41.1518 60.3283 39.0759 62.889 39.0759C65.4497 39.0759 67.5256 41.1518 67.5256 43.7125Z",
    fill: "#2D0067"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.3572 60.0924L66.1414 64.0899L67.5553 62.0534L72.2428 65.3079L70.1165 68.3705C68.893 70.1327 66.554 70.7169 64.6457 69.7369L59.8677 67.2832L54.859 73.4484L50.4299 69.8501L58.3572 60.0924Z",
    fill: "#2D0067"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0068 48.9451L74.6397 56.2016L73.6318 59.6229L48.999 52.3663L50.0068 48.9451Z",
    fill: "#2D0067"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManedsbelp);
export default __webpack_public_path__ + "static/media/Månedsbeløp.4b290210223a1502e37496d5585957a3.svg";
export { ForwardRef as ReactComponent };